import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { videoURL } from 'src/app/services/base-url';
import { TvProductionTrackerService } from 'src/app/services/tv-production-tracker.service';

@Component({
  selector: 'app-tv-production-tracker-filter',
  templateUrl: './tv-production-tracker-filter.component.html',
  styleUrls: ['./tv-production-tracker-filter.component.css']
})
export class TvProductionTrackerFilterComponent implements OnInit {

  statusMap: any = {
    'CREATED': 'Created',
    'EDITOR_ASSIGNED': 'Editor Assigned',
    'EDIT_COMPLETED': 'Edit Completed',
    'TITLE_ASSIGNED': 'Title Assigned',
    'TITLE_COMPLETED': 'Title Completed',
    'GRAPHICS_ASSIGNED': 'Graphics Assigned',
    'GRAPHICS_COMPLETED': 'Graphics Completed',
    'SEO_ASSIGNED': 'SEO Assigned',
    'SEO_COMPLETED': 'SEO Completed',
    'QUALITY_CHECK_ASSIGNED': 'Quality Check Assigned',
    'QUALITY_CHECK_COMPLETED': 'Quality Check Completed',
    'PUBLISHING_ASSIGNED': 'Publishing Assigned',
    'PUBLISHING_COMPLETED': 'Publishing Completed',
    'COMPLETED': 'Completed',
    'PENDING': 'Pending',
    'EPISODE_CREATION': 'Episode Creation'
  };

  episodeStatuses = [
    { key: 'CREATED', label: 'Created' },
    { key: 'EDITOR_ASSIGNED', label: 'Editor Assigned' },
    { key: 'EDIT_COMPLETED', label: 'Edit Completed' },
    { key: 'TITLE_ASSIGNED', label: 'Title Assigned' },
    { key: 'TITLE_COMPLETED', label: 'Title Completed' },
    { key: 'GRAPHICS_ASSIGNED', label: 'Graphics Assigned' },
    { key: 'GRAPHICS_COMPLETED', label: 'Graphics Completed' },
    { key: 'SEO_ASSIGNED', label: 'SEO Assigned' },
    { key: 'SEO_COMPLETED', label: 'SEO Completed' },
    { key: 'QUALITY_CHECK_ASSIGNED', label: 'Quality Check Assigned' },
    { key: 'QUALITY_CHECK_COMPLETED', label: 'Quality Check Completed' },
    { key: 'PUBLISHING_ASSIGNED', label: 'Publishing Assigned' },
    { key: 'PUBLISHING_COMPLETED', label: 'Publishing Completed' },
    { key: 'COMPLETED', label: 'Completed' },
    { key: 'PENDING', label: 'Pending' },
    { key: 'EPISODE_CREATION', label: 'Episode Creation' }
  ];

  episodeTypes: string[] = [
    'Full Episode',
    'Interview',
    'Shorts',
    'Live Event',
    'Promo',
    'News'
  ];



  episodeList: any[] = [];
  pageNumber: number = 1;
  totalRecords: number = 0;
  first: number = 0;
  tableSize: number = 10;
  isLoading: boolean = false;

  selectedFilter: string = 'wildSearch';
  searchKey: string = "";
  startDate: any = "";
  endDate: any = "";

  episodeType: string = "";
  episodeStatus: string = "";
  loggedInUserId: any;
  videoUrl: any = videoURL

  constructor(
    private tvProductionTrackerService: TvProductionTrackerService,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {
    this.loggedInUserId = Number(sessionStorage.getItem('userId')) || 0;
    this.getAllEpisodes();
  }

  getAllEpisodes() {
    this.isLoading = true;
    this.tvProductionTrackerService.getAllEpisodes().subscribe(
      (res: any) => {
        this.handleResponse(res);
      },
      (err: any) => {
        this.handleError(err);
      }
    );
  }

  handleResponse(res: any) {
    this.isLoading = false;
    if (res && res.response) {
      this.episodeList = Array.isArray(res.response) ? res.response : [res.response];
      this.totalRecords = this.episodeList.length;
    } else {
      this.episodeList = [];
      this.totalRecords = 0;
    }
  }

  handleError(err: any) {
    console.error(err);
    this.isLoading = false;
    this.toastr.error("An error occurred while fetching data");
  }

  onTableDataChange(event: any) {
    this.pageNumber = event.page + 1;
  }

  onFilterChange(filterType: string) {
    this.selectedFilter = filterType;
  }

  applyFilter() {
    if (this.selectedFilter === 'wildSearch') {
      if (!this.searchKey || this.searchKey.trim() === '') {
        this.toastr.warning("Please enter search keyword");
        return;
      }
      this.isLoading = true;
      this.tvProductionTrackerService.filterByWildSearch({ searchKey: this.searchKey.trim() }).subscribe(
        (res: any) => this.handleResponse(res),
        (err: any) => this.handleError(err)
      );
    } else if (this.selectedFilter === 'shootDate') {
      if (!this.startDate || !this.endDate) {
        this.toastr.warning("Please select start and end dates");
        return;
      }
      const start = new Date(this.startDate).getTime();
      const end = new Date(this.endDate).getTime();
      this.isLoading = true;
      this.tvProductionTrackerService.filterByShootDate({ startDate: start, endDate: end }).subscribe(
        (res: any) => this.handleResponse(res),
        (err: any) => this.handleError(err)
      );

    } else if (this.selectedFilter === 'episodeType') {
      if (!this.episodeType) {
        this.toastr.warning("Please select episode type");
        return;
      }
      this.isLoading = true;
      this.tvProductionTrackerService.filterByEpisodeType({ episodeType: this.episodeType }).subscribe(
        (res: any) => this.handleResponse(res),
        (err: any) => this.handleError(err)
      );
    } else if (this.selectedFilter === 'episodeStatus') {
      if (!this.episodeStatus) {
        this.toastr.warning("Please select episode status");
        return;
      }
      this.isLoading = true;
      this.tvProductionTrackerService.filterByEpisodeStatus({ episodeStatus: this.episodeStatus }).subscribe(
        (res: any) => this.handleResponse(res),
        (err: any) => this.handleError(err)
      );
    }
  }

  resetFilter() {
    this.searchKey = "";
    this.startDate = "";
    this.endDate = "";

    this.episodeType = "";
    this.episodeStatus = "";
    this.pageNumber = 1;
    this.first = 0;
    this.getAllEpisodes();
  }

  singleEpisodeData: any = [];
  workflowSteps = [
    { stage: 'EPISODE_CREATION', label: 'Shoot' },
    { stage: 'EDITOR', label: 'Edit' },
    { stage: 'GRAPHICS', label: 'Graphics' },
    { stage: 'TITLE', label: 'Title' },
    { stage: 'QUALITY_CHECK', label: 'Quality Check' },
    { stage: 'SEO', label: 'SEO' },
    { stage: 'COMPLETED', label: 'Completed' }
  ];

  isStageCompleted(currentStage: string, stepStage: string): boolean {
    if (!currentStage) currentStage = 'EPISODE_CREATION';
    if (stepStage === 'COMPLETED') {
      return currentStage === 'COMPLETED';
    }
    const stageOrder = ['EPISODE_CREATION', 'EDITOR', 'GRAPHICS', 'TITLE', 'QUALITY_CHECK', 'SEO', 'PUBLISHING', 'COMPLETED'];
    const currentIndex = stageOrder.indexOf(currentStage);
    const stepIndex = stageOrder.indexOf(stepStage);
    if (currentIndex === -1 || stepIndex === -1) return false;
    return currentIndex > stepIndex || currentStage === 'COMPLETED';
  }

  isStageActive(currentStage: string, stepStage: string): boolean {
    if (!currentStage) currentStage = 'EPISODE_CREATION';
    return currentStage === stepStage;
  }

  viewEpisodeById(id: any) {
    this.tvProductionTrackerService.getEpisodeById(id).subscribe(
      (res: any) => {
        if (res && res.response) {
          this.singleEpisodeData = [res.response];
        } else {
          this.singleEpisodeData = [];
        }
      },
      (err: any) => {
        console.error(err);
        this.toastr.error("Failed to load episode details");
      }
    );
  }
  closePopUp() {
    // Do not clear singleEpisodeData synchronously on close so that modal body and footer do not disappear during Bootstrap fade out animation.
  }

  isMyNote(note: any): boolean {
    if (!note || note.userId === undefined || note.userId === null) return false;
    return Number(note.userId) === Number(this.loggedInUserId);
  }
}
